export default "__VITE_ASSET__cXsy9inn__"